import { fireCTABIEvent, fireScrollEvent } from 'public/bi-events.js';
import wixLocation from 'wix-location';

const pageCTAs = [{
        btnBoxId: '#addYourBadgeBtnBox',
        btnLcation: 'Second fold'
    },
    {
        btnBoxId: '#comeBackAliveBtnBox',
        btnLcation: 'Third fold'
    },
    {
        btnBoxId: '#NBUbtnBox',
        btnLcation: 'Third fold'
    },
    {
        btnBoxId: '#razomBtnBox',
        btnLcation: 'Third fold'
    },
    {
        btnBoxId: '#ICRCbtnBox',
        btnLcation: 'Third fold'
    },
    {
        btnBoxId: '#novaUkraineBtnBox',
        btnLcation: 'Third fold'
    },
];

$w.onReady(function () {
    initBIEvents();
});

function initBIEvents() {
    pageCTAs.forEach(obj => {
        const buttonBox = $w(obj.btnBoxId);
        const button = buttonBox.children[0];

        button.onClick(() => {
            fireButtonsBIEvents(button.label, obj.btnLcation, button.link);
        });

    });

    $w('#footer1').onViewportEnter(() => {
        fireScrollEvent(19, 125102, { lp_name: 'stand with ukraine lp' });
    });
}

function fireButtonsBIEvents(btnLabel, btnLcation, btnLink) {
    const biFields = {
        button_name: btnLabel,
        page_url: wixLocation.url,
        is_valid: true,
        additional_info: btnLcation,
        target_url: btnLink,
        topic: 'stand with ukraine lp'
    }

    fireCTABIEvent(19, 703, biFields);
}